import { CheckCircle2 } from "lucide-react";

const money = (v, cur) => (v == null ? null : `$${Number(v).toLocaleString("es-MX", { maximumFractionDigits: 2 })} ${cur || ""}`.trim());

export const ClosedBadge = ({ o, testid = "opportunity-closed-badge" }) => {
  if (!o?.cerrado) return null;
  const parts = [money(o.monto_negocio, o.cierre_moneda), o.comision_monto != null && `comisión ${money(o.comision_monto, o.cierre_moneda)}`].filter(Boolean);
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1 text-[10px] font-bold px-1.5 py-0.5 rounded border border-emerald-500/50 text-emerald-700 dark:text-emerald-400 bg-emerald-500/10">
      <CheckCircle2 className="w-3 h-3" /> Cerrado{parts.length ? ` · ${parts.join(" · ")}` : ""}
    </span>
  );
};
